import React from "react";
import { ChevronRight } from '@mui/icons-material';
import './SectionHeader.scss';
import { useConfig } from "../../../../context/ConfigContext";
import { theme } from "../../../../constants/theme";
import { getIcon, getIconBackgroundColors } from "../../../../utils/iconUtils";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  iconName?: string;
  onPressSeeAll?: () => void;
  showSeeAll?: boolean;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  iconName = "star",
  onPressSeeAll,
  showSeeAll = true,
}) => {
  const { config } = useConfig();
  const primaryColor = config?.primaryColor || String(theme.colors.primary);
  
  // Get icon background colors
  const { bgColor: iconBgColor, bgLight: iconBgLight } = getIconBackgroundColors(primaryColor);

  return (
    <div
      className={`section-header ${onPressSeeAll ? 'clickable' : ''}`}
      onClick={onPressSeeAll}
      style={{
        '--icon-bg-color': iconBgColor,
        '--icon-bg-light': iconBgLight,
      } as React.CSSProperties}
    >
      <div className="section-header-left">
        {iconName && (
          <div className="icon-container">
            {getIcon({ iconName, color: primaryColor })}
          </div>
        )}
        <div className="text-container">
          <div className="title">{title}</div>
          {subtitle && <div className="subtitle">{subtitle}</div>}
        </div>
      </div>

      {showSeeAll && onPressSeeAll && (
        <div className="section-header-right">
          <span 
            className="see-all-text"
            style={{ color: primaryColor }}
          >
            Voir tout
          </span>
          <ChevronRight 
            className="chevron-icon"
            style={{ color: primaryColor }}
          />
        </div>
      )}
    </div>
  );
};

export default SectionHeader;